<template>
  <div class="login">
    <van-image style="width: 100%;background-size: cover;" src="/img/login.png" />
    <van-cell-group>
      <van-field
        v-model="loginForm.username"
        clearable
        label="账号"
        placeholder="请输入用户名"
        left-icon="manager"
      />
      <van-field
        v-model="loginForm.password"
        type="password"
        label="密码"
        placeholder="请输入密码"
        left-icon="lock"
      />
    </van-cell-group>
    <div style="height:1rem"></div>
    <div class="btn">
      <van-button
        type="warning"
        style="font-size: 0.47333rem;background: #30cca8;border-radius: 50px;border: 0.02667rem solid #30cca8;font-weight:bold"
        @click="login"
      >登&nbsp;录</van-button>
    </div>

    <div
      v-show="bottom_tip"
      style="font-size:10px;text-align:center;padding:10px 10px"
    >©2020 一脉阳光集团信息中心</div>
  </div>
</template>

<script>
import { Field, CellGroup, Image, Icon, Toast, Button } from "vant";
import { mapMutations } from "vuex";
export default {
  components: {
    [Image.name]: Image,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [CellGroup.name]: CellGroup,
  },
  data() {
    return {
      bottom_tip: true,
      loginForm: {
        username: "",
        password: "",
      },
      preroute: "",
    };
  },
  methods: {
    ...mapMutations(["changeUser", "changeToken","changeDefaultAgentIndex"]),
    login() {
      //Toast("Sorry,系统维护中,禁止使用");
      if (this.loginForm.username === null || this.loginForm.username === "") {
        Toast("账号不能为空");
        return;
      }
      if (this.loginForm.password === null || this.loginForm.password === "") {
        Toast("密码不能为空");
        return;
      }

      let _this = this;
      this.$http({
        method: "post",
        url: "/consumable/login",
        data: this.loginForm,
      }).then(function (response) {
        if (response.user && response.token) {
          _this.changeUser(response.user);
          _this.changeToken(response.token);
          _this.$router.push("/index");
        }
      });
    },
    getUrlParams() {
      // 不传name返回所有值，否则返回对应值
      var url = window.location.href;
      if (url.indexOf("t=") != -1) {
        return false;
      }
      if (url.indexOf("?") != -1) {
        var split = url.split("?")[1].split("=")[1];

        if (split.indexOf("#") != -1) {
          return split.split("#")[0];
        } else {
          return split;
        }
      }
      return null;
    },
    getOAUrlParams(){
      var url = window.location.href;
      // 获取?之后的参数字符串
      var _params = url.split('?')[1];
      var paramData = [];
      if (!_params) {
        return paramData
      }
      //参数字符串分割为数组
      let cs_arr = _params.split('&');
      // alert(cs_arr.length);
      for (let i = 0; i < cs_arr.length; i++) {
        //遍历数组，拿到对象
         paramData[cs_arr[i].split('=')[0]]=cs_arr[i].split('=')[1];
      }
      return paramData;
    },

    getReferer() {
      if (document.referrer) {
        return document.referrer;
      } else {
        return false;
      }
    },
  },
  mounted() {

    //Toast("Sorry,系统维护中,禁止使用");
    var res1 = this.getUrlParams();//获取url中参数
    var data = this.getOAUrlParams();//获取url中参数
    var ref = this.getReferer();//获取前一页面的url
    // var url = window.location.href;
    // alert(res1);
    // alert(ref);
    if (!res1||!data) {
      return false;
    }
    window.console.log(data); // 1
    var patt = /dingding.rimag.com.cn/;
    // var patt = /rimag.com.cn/;
    var retun = patt.test(ref);
    if (retun == true) {
      let _this = this;
      this.$http({
        method: "post",
        url: "/consumable/login",
        data: { username: res1, dingdingtoken: "asfsrwerwr" },
      }).then(function (response) {
        if (response.user && response.token) {
          _this.changeUser(response.user);
          _this.changeToken(response.token);
          _this.$router.push("/index");
        }
      });
    }
    //oa移动端免登接口
    var patt2 = /oa.rimag.com.cn/;
  //  var patt2 = /172.17.20.30:89/;oa移动端测试地址
    var retun2 = patt2.test(ref);
    // alert(retun2);
    if (retun2 == true) {
      let _this = this;
      this.$http({
        method: "post",
        url: "/consumable/login",
        data: { loginid: data['loginid'], stamp:data['stamp'],token:data['token']},
      }).then(function (response) {
        if (response.user && response.token) {
          _this.changeUser(response.user);
          _this.changeToken(response.token);
          _this.$router.push("/index");
        }
      });
    }

    //待审核单据免登录跳转
    var patt3 = new RegExp(process.env.VUE_APP_REF_URL);
    var retun3 = patt3.test(ref);
    if (retun3 == true) {
      let _this = this;
      var username = this.$route.query.username;//获取url中参数
      var callback = this.$route.query.callback;//获取url中参数中回调地址
      var check_id = this.$route.query.check_id;//获取url中参数审核id
      this.$http({
        method: "post",
        url: "/consumable/login",
        data: { username: username, system:ref,callback:callback,check_id:check_id},
      }).then(function (response) {
        if (response.user && response.token) {
          _this.changeUser(response.user);
          _this.changeToken(response.token);
          _this.changeDefaultAgentIndex(response.agent_id);
          if(response.callback&& response.check_id){
            _this.$router.push(response.callback+"?id="+response.check_id);
          }else{
            _this.$router.push("/index");
          }
        }
      });
    }

  },


  
};
</script>

<style lang="less">
.login {
  .van-image__img {
    height: 4.8rem;
  }
  .van-button {
    width: 94%;
  }
}
.btn {
  text-align: center;
}
</style>
